/**
 * Personal Map PM-2 多國語系文案（不經工程語意外洩）。
 */

export const personalMapMessagesZhTW = {
  'travel.nav.personalMap': '我的地圖',
  'travel.nav.personalMapHint': '查看你分享與建立過的地點',
  'travel.personalMap.title': '我的地圖',
  'travel.personalMap.subtitle': '只有你看得到',
  'travel.personalMap.privacyHint': '此地圖為私人內容，不會公開給其他人。',
  'travel.personalMap.back': '返回',
  'travel.personalMap.viewMap': '地圖',
  'travel.personalMap.viewList': '清單',
  'travel.personalMap.viewToggle': '檢視方式',
  'travel.personalMap.filters': '篩選',
  'travel.personalMap.filterSource': '來源',
  'travel.personalMap.filterCategory': '分類',
  'travel.personalMap.filterAll': '全部',
  'travel.personalMap.filterPlace': '打卡',
  'travel.personalMap.filterFood': '美食',
  'travel.personalMap.filterCustom': '自訂地',
  'travel.personalMap.clearFilters': '清除篩選',
  'travel.personalMap.showHidden': '顯示已隱藏',
  'travel.personalMap.loading': '載入我的地圖…',
  'travel.personalMap.loadFailed': '無法載入我的地圖',
  'travel.personalMap.retry': '再試一次',
  'travel.personalMap.loadMore': '載入更多',
  'travel.personalMap.loadingMore': '載入更多…',
  'travel.personalMap.paginationFailed': '無法載入更多地點',
  'travel.personalMap.emptyAllTitle': '還沒有地圖上的地點',
  'travel.personalMap.emptyAllHint': '分享打卡、美食貼文或建立自訂地點後，會出現在這裡。',
  'travel.personalMap.emptyFilterTitle': '沒有符合篩選的地點',
  'travel.personalMap.emptyFilterHint': '試試清除篩選，或換一個來源／分類。',
  'travel.personalMap.emptyViewportTitle': '此範圍沒有地點',
  'travel.personalMap.emptyViewportHint': '移動地圖或切換清單檢視查看其他地點。',
  'travel.personalMap.mapUnavailable': '地圖暫時無法顯示，仍可使用清單檢視。',
  'travel.personalMap.unnamedPlace': '未命名地點',
  'travel.personalMap.lastActivity': '最近活動',
  'travel.personalMap.sources': '來源',
  'travel.personalMap.hiddenBadge': '已隱藏',
  'travel.personalMap.category.checkIn': '打卡',
  'travel.personalMap.category.food': '美食',
  'travel.personalMap.category.custom': '自訂地',
  'travel.personalMap.category.mixed': '混合',
  'travel.personalMap.category.place': '地點',
  'travel.personalMap.source.placePost': '打卡貼文',
  'travel.personalMap.source.foodPost': '美食貼文',
  'travel.personalMap.source.customLocation': '自訂地點',
  'travel.personalMap.source.unknown': '其他來源',
  'travel.personalMap.previewClose': '關閉',
  'travel.personalMap.hide': '從地圖隱藏',
  'travel.personalMap.hideConfirmTitle': '從我的地圖隱藏這個地點？',
  'travel.personalMap.hideConfirmBody': '原始貼文或自訂地點不會被刪除。',
  'travel.personalMap.hideConfirmAction': '隱藏',
  'travel.personalMap.hideCancel': '取消',
  'travel.personalMap.hidePending': '隱藏中…',
  'travel.personalMap.hideFailed': '無法隱藏此地點',
  'travel.personalMap.restore': '取消隱藏',
  'travel.personalMap.restorePending': '還原中…',
  'travel.personalMap.restoreFailed': '無法取消隱藏',
  'travel.personalMap.noCoordinates': '此項目沒有可用座標，僅能在清單中查看。',
  'travel.personalMap.addToJourney': '加入行程',
  'travel.personalMap.addToJourneyUnavailable': '這個地點目前無法加入行程',
  'travel.personalMap.addToJourney.selectJourneyTitle': '選擇行程',
  'travel.personalMap.addToJourney.selectDayTitle': '選擇日期',
  'travel.personalMap.addToJourney.cancel': '取消',
  'travel.personalMap.addToJourney.loadingJourneys': '載入行程…',
  'travel.personalMap.addToJourney.loadFailed': '無法載入行程',
  'travel.personalMap.addToJourney.emptyTitle': '尚無可加入的行程',
  'travel.personalMap.addToJourney.emptyHint': '先建立行程，再把這個地點加入行程。',
  'travel.personalMap.addToJourney.createJourney': '建立行程',
  'travel.personalMap.addToJourney.journeyListLabel': '可編輯的行程',
  'travel.personalMap.addToJourney.nextDay': '下一步：選擇日期',
  'travel.personalMap.addToJourney.backToJourneys': '返回行程列表',
  'travel.personalMap.addToJourney.loadingDays': '載入行程日…',
  'travel.personalMap.addToJourney.daysLoadFailed': '無法載入行程日',
  'travel.personalMap.addToJourney.daysEmptyTitle': '這個行程還沒有日期',
  'travel.personalMap.addToJourney.daysEmptyHint': '請先到行程編輯新增日期，再回來加入地點。',
  'travel.personalMap.addToJourney.goPlanning': '前往行程編輯',
  'travel.personalMap.addToJourney.dayListLabel': '行程日',
  'travel.personalMap.addToJourney.confirmDay': '加入此日行程',
  'travel.personalMap.addToJourney.dayFallback': '第 {n} 天',
  'travel.personalMap.addToJourney.duplicateWarning': '這一天已安排過相同地點，你仍可以再次加入。',
  'travel.personalMap.addToJourney.handoffInvalid': '無法帶入此地點，請從我的地圖重新加入。',
  'travel.personalMap.addToJourney.prefillHint': '已帶入地點，確認後再儲存安排。',
};

export const personalMapMessagesEn = {
  'travel.nav.personalMap': 'My map',
  'travel.nav.personalMapHint': 'Places you shared or created',
  'travel.personalMap.title': 'My map',
  'travel.personalMap.subtitle': 'Only you can see this',
  'travel.personalMap.privacyHint': 'This map is private and not shared with others.',
  'travel.personalMap.back': 'Back',
  'travel.personalMap.viewMap': 'Map',
  'travel.personalMap.viewList': 'List',
  'travel.personalMap.viewToggle': 'View mode',
  'travel.personalMap.filters': 'Filters',
  'travel.personalMap.filterSource': 'Source',
  'travel.personalMap.filterCategory': 'Category',
  'travel.personalMap.filterAll': 'All',
  'travel.personalMap.filterPlace': 'Check-in',
  'travel.personalMap.filterFood': 'Food',
  'travel.personalMap.filterCustom': 'Custom place',
  'travel.personalMap.clearFilters': 'Clear filters',
  'travel.personalMap.showHidden': 'Show hidden',
  'travel.personalMap.loading': 'Loading your map…',
  'travel.personalMap.loadFailed': 'Could not load your map',
  'travel.personalMap.retry': 'Try again',
  'travel.personalMap.loadMore': 'Load more',
  'travel.personalMap.loadingMore': 'Loading more…',
  'travel.personalMap.paginationFailed': 'Could not load more places',
  'travel.personalMap.emptyAllTitle': 'No places on your map yet',
  'travel.personalMap.emptyAllHint': 'Check-ins, food posts, or custom places you create will show up here.',
  'travel.personalMap.emptyFilterTitle': 'No places match these filters',
  'travel.personalMap.emptyFilterHint': 'Clear filters or try another source or category.',
  'travel.personalMap.emptyViewportTitle': 'No places in this area',
  'travel.personalMap.emptyViewportHint': 'Move the map or switch to list view.',
  'travel.personalMap.mapUnavailable': 'Map is unavailable. You can still use the list.',
  'travel.personalMap.unnamedPlace': 'Unnamed place',
  'travel.personalMap.lastActivity': 'Last activity',
  'travel.personalMap.sources': 'Sources',
  'travel.personalMap.hiddenBadge': 'Hidden',
  'travel.personalMap.category.checkIn': 'Check-in',
  'travel.personalMap.category.food': 'Food',
  'travel.personalMap.category.custom': 'Custom',
  'travel.personalMap.category.mixed': 'Mixed',
  'travel.personalMap.category.place': 'Place',
  'travel.personalMap.source.placePost': 'Check-in post',
  'travel.personalMap.source.foodPost': 'Food post',
  'travel.personalMap.source.customLocation': 'Custom place',
  'travel.personalMap.source.unknown': 'Other source',
  'travel.personalMap.previewClose': 'Close',
  'travel.personalMap.hide': 'Hide from map',
  'travel.personalMap.hideConfirmTitle': 'Hide this place from your map?',
  'travel.personalMap.hideConfirmBody': 'Your original post or custom place will not be deleted.',
  'travel.personalMap.hideConfirmAction': 'Hide',
  'travel.personalMap.hideCancel': 'Cancel',
  'travel.personalMap.hidePending': 'Hiding…',
  'travel.personalMap.hideFailed': 'Could not hide this place',
  'travel.personalMap.restore': 'Unhide',
  'travel.personalMap.restorePending': 'Restoring…',
  'travel.personalMap.restoreFailed': 'Could not unhide this place',
  'travel.personalMap.noCoordinates': 'This item has no coordinates and is list-only.',
  'travel.personalMap.addToJourney': 'Add to trip',
  'travel.personalMap.addToJourneyUnavailable': 'This place cannot be added to a trip right now',
  'travel.personalMap.addToJourney.selectJourneyTitle': 'Choose a trip',
  'travel.personalMap.addToJourney.selectDayTitle': 'Choose a day',
  'travel.personalMap.addToJourney.cancel': 'Cancel',
  'travel.personalMap.addToJourney.loadingJourneys': 'Loading trips…',
  'travel.personalMap.addToJourney.loadFailed': 'Could not load trips',
  'travel.personalMap.addToJourney.emptyTitle': 'No trips to add to yet',
  'travel.personalMap.addToJourney.emptyHint': 'Create a trip first, then add this place.',
  'travel.personalMap.addToJourney.createJourney': 'Create trip',
  'travel.personalMap.addToJourney.journeyListLabel': 'Editable trips',
  'travel.personalMap.addToJourney.nextDay': 'Next: choose a day',
  'travel.personalMap.addToJourney.backToJourneys': 'Back to trips',
  'travel.personalMap.addToJourney.loadingDays': 'Loading days…',
  'travel.personalMap.addToJourney.daysLoadFailed': 'Could not load days',
  'travel.personalMap.addToJourney.daysEmptyTitle': 'This trip has no days yet',
  'travel.personalMap.addToJourney.daysEmptyHint': 'Add a day in trip planning, then come back to add this place.',
  'travel.personalMap.addToJourney.goPlanning': 'Go to trip planning',
  'travel.personalMap.addToJourney.dayListLabel': 'Trip days',
  'travel.personalMap.addToJourney.confirmDay': 'Add to this day',
  'travel.personalMap.addToJourney.dayFallback': 'Day {n}',
  'travel.personalMap.addToJourney.duplicateWarning': 'This place is already on this day. You can still add it again.',
  'travel.personalMap.addToJourney.handoffInvalid': 'Could not carry this place over. Please add it again from your map.',
  'travel.personalMap.addToJourney.prefillHint': 'Place filled in — confirm before saving.',
};

export const personalMapMessagesZhCN = {
  'travel.nav.personalMap': '我的地图',
  'travel.nav.personalMapHint': '查看你分享与建立过的地点',
  'travel.personalMap.title': '我的地图',
  'travel.personalMap.subtitle': '只有你看得到',
  'travel.personalMap.privacyHint': '此地图为私人内容，不会公开给其他人。',
  'travel.personalMap.back': '返回',
  'travel.personalMap.viewMap': '地图',
  'travel.personalMap.viewList': '列表',
  'travel.personalMap.viewToggle': '查看方式',
  'travel.personalMap.filters': '筛选',
  'travel.personalMap.filterSource': '来源',
  'travel.personalMap.filterCategory': '分类',
  'travel.personalMap.filterAll': '全部',
  'travel.personalMap.filterPlace': '打卡',
  'travel.personalMap.filterFood': '美食',
  'travel.personalMap.filterCustom': '自定义地点',
  'travel.personalMap.clearFilters': '清除筛选',
  'travel.personalMap.showHidden': '显示已隐藏',
  'travel.personalMap.loading': '加载我的地图…',
  'travel.personalMap.loadFailed': '无法加载我的地图',
  'travel.personalMap.retry': '再试一次',
  'travel.personalMap.loadMore': '加载更多',
  'travel.personalMap.loadingMore': '加载更多…',
  'travel.personalMap.paginationFailed': '无法加载更多地点',
  'travel.personalMap.emptyAllTitle': '还没有地图上的地点',
  'travel.personalMap.emptyAllHint': '分享打卡、美食帖文或建立自定义地点后，会出现在这里。',
  'travel.personalMap.emptyFilterTitle': '没有符合筛选的地点',
  'travel.personalMap.emptyFilterHint': '试试清除筛选，或换一个来源／分类。',
  'travel.personalMap.emptyViewportTitle': '此范围没有地点',
  'travel.personalMap.emptyViewportHint': '移动地图或切换列表查看其他地点。',
  'travel.personalMap.mapUnavailable': '地图暂时无法显示，仍可使用列表。',
  'travel.personalMap.unnamedPlace': '未命名地点',
  'travel.personalMap.lastActivity': '最近活动',
  'travel.personalMap.sources': '来源',
  'travel.personalMap.hiddenBadge': '已隐藏',
  'travel.personalMap.category.checkIn': '打卡',
  'travel.personalMap.category.food': '美食',
  'travel.personalMap.category.custom': '自定义',
  'travel.personalMap.category.mixed': '混合',
  'travel.personalMap.category.place': '地点',
  'travel.personalMap.source.placePost': '打卡帖文',
  'travel.personalMap.source.foodPost': '美食帖文',
  'travel.personalMap.source.customLocation': '自定义地点',
  'travel.personalMap.source.unknown': '其他来源',
  'travel.personalMap.previewClose': '关闭',
  'travel.personalMap.hide': '从地图隐藏',
  'travel.personalMap.hideConfirmTitle': '从我的地图隐藏这个地点？',
  'travel.personalMap.hideConfirmBody': '原始帖文或自定义地点不会被删除。',
  'travel.personalMap.hideConfirmAction': '隐藏',
  'travel.personalMap.hideCancel': '取消',
  'travel.personalMap.hidePending': '隐藏中…',
  'travel.personalMap.hideFailed': '无法隐藏此地点',
  'travel.personalMap.restore': '取消隐藏',
  'travel.personalMap.restorePending': '还原中…',
  'travel.personalMap.restoreFailed': '无法取消隐藏',
  'travel.personalMap.noCoordinates': '此项目没有可用坐标，仅能在列表中查看。',
  'travel.personalMap.addToJourney': '加入行程',
  'travel.personalMap.addToJourneyUnavailable': '这个地点目前无法加入行程',
  'travel.personalMap.addToJourney.selectJourneyTitle': '选择行程',
  'travel.personalMap.addToJourney.selectDayTitle': '选择日期',
  'travel.personalMap.addToJourney.cancel': '取消',
  'travel.personalMap.addToJourney.loadingJourneys': '加载行程…',
  'travel.personalMap.addToJourney.loadFailed': '无法加载行程',
  'travel.personalMap.addToJourney.emptyTitle': '尚无可加入的行程',
  'travel.personalMap.addToJourney.emptyHint': '先建立行程，再把这个地点加入行程。',
  'travel.personalMap.addToJourney.createJourney': '建立行程',
  'travel.personalMap.addToJourney.journeyListLabel': '可编辑的行程',
  'travel.personalMap.addToJourney.nextDay': '下一步：选择日期',
  'travel.personalMap.addToJourney.backToJourneys': '返回行程列表',
  'travel.personalMap.addToJourney.loadingDays': '加载行程日…',
  'travel.personalMap.addToJourney.daysLoadFailed': '无法加载行程日',
  'travel.personalMap.addToJourney.daysEmptyTitle': '这个行程还没有日期',
  'travel.personalMap.addToJourney.daysEmptyHint': '请先到行程编辑新增日期，再回来加入地点。',
  'travel.personalMap.addToJourney.goPlanning': '前往行程编辑',
  'travel.personalMap.addToJourney.dayListLabel': '行程日',
  'travel.personalMap.addToJourney.confirmDay': '加入此日行程',
  'travel.personalMap.addToJourney.dayFallback': '第 {n} 天',
  'travel.personalMap.addToJourney.duplicateWarning': '这一天已安排过相同地点，你仍可以再次加入。',
  'travel.personalMap.addToJourney.handoffInvalid': '无法带入此地点，请从我的地图重新加入。',
  'travel.personalMap.addToJourney.prefillHint': '已带入地点，确认后再保存安排。',
};

export function getPersonalMapMessage(locale, key) {
  const pack = locale === 'en_US' || locale === 'en'
    ? personalMapMessagesEn
    : locale === 'zh_CN' || locale === 'zh-CN'
      ? personalMapMessagesZhCN
      : personalMapMessagesZhTW;
  return pack[key] || key;
}
